import React from 'react';
import { useStoreSettings } from '../context/StoreSettingsContext';

function Contact() {
  const { settings } = useStoreSettings();
  const { whatsapp_number, social } = settings;

  return (
    <div className="container" style={{ padding: '64px 0 96px', maxWidth: 760 }}>
      <span className="section-label">Contact</span>
      <h1 style={{ marginBottom: 20 }}>Get in touch</h1>
      <p style={{ marginBottom: 28 }}>
        Questions about an order, a product, or anything else? Reach out
        and we'll get back to you.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {whatsapp_number && (
          <a className="btn btn-primary" style={{ alignSelf: 'flex-start' }}
             href={`https://wa.me/${whatsapp_number}`} target="_blank" rel="noreferrer">
            WhatsApp Us
          </a>
        )}
        {social?.instagram && (
          <a href={social.instagram} target="_blank" rel="noreferrer" style={{ color: 'var(--brand)' }}>Instagram</a>
        )}
        {social?.facebook && (
          <a href={social.facebook} target="_blank" rel="noreferrer" style={{ color: 'var(--brand)' }}>Facebook</a>
        )}
      </div>
    </div>
  );
}

export default Contact;
